<template>
    <div
        class="inline-flex items-center justify-center rounded-full bg-cover bg-no-repeat"
        :class="[backgroundClassName, textClassName, className]"
        :style="style"
    >
        <slot>
            <span v-if="!src">{{ userInitial }}</span>
        </slot>
    </div>
</template>

<script>
    export default {
        props: {
            username: {
                type: String,
                required: true,
            },
            initials: {
                type: String,
                default: '',
            },
            backgroundClassName: {
                type: String,
                default: 'bg-gray-400',
            },
            textClassName: {
                type: String,
                default: 'text-white text-xl',
            },
            className: {
                type: String,
                default: 'h-11 w-11',
            },
            src: {
                type: String,
                default: '',
            },
        },

        computed: {
            isImage() {
                return !!this.src;
            },

            style() {
                if (!this.isImage) {
                    return '';
                }

                return {
                    backgroundImage: `url(${this.src})`,
                };
            },

            userInitial() {
                const initials = this.initials || this.initial(this.username);
                return initials;
            },
        },

        methods: {
            initial(username) {
                const parts = username.split(/[ -]/);
                let initials = '';

                for (let i = 0; i < parts.length; i++) {
                    initials += parts[i].charAt(0);
                }

                if (initials.length > 3 && initials.search(/[A-Z]/) !== -1) {
                    initials = initials.replace(/[a-z]+/g, '');
                }

                initials = initials.substr(0, 3).toUpperCase();

                return initials;
            },
        },
    };
</script>
